export const URI = "https://socialarchivedd.scoliadarts.com";
export const dummyImgUrl = "https://dummyimage.com/1920x1080";
